import React from 'react';

import styled from '@emotion/styled';

import BarChart from '../../../components/Charts/BarChart';
import RouteAnalysisTooltip from '../../../components/Charts/CustomToolTips/RouteAnalysisTooltip';
import { theme } from '../../../globalStyles';

const VehicleVolumeType = () => {
  const vehicleVolumeData = [
    { name: 'Keke', value: 54 },
    { name: 'Bus', value: 20 },
    { name: 'Van', value: 36 },
    { name: 'Truck', value: 54 },
    { name: 'Bicycle', value: 40 },
    { name: 'Tankers', value: 10 },
  ];

  return (
    <Container>
      <Label>Ratings and Trip logs</Label>
      <BarChart
        xAxisDataKey='name'
        data={vehicleVolumeData}
        isAnimationActive={true}
        dataKeys={['value']}
        // fills={['#5B91F5']}
        fills={[theme.palette.blueColor, theme.palette.lightBlueOpacity]}
        showLegend={false}
        // yLabel='Average Tier Score per month'
        externalTooltip={{ content: <RouteAnalysisTooltip /> }}
      />
    </Container>
  );
};

export default VehicleVolumeType;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 16px 16px;
  border-radius: 8px;
  gap: 20px;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 30px;
  margin-left: 12px;
  /* margin-bottom: 39px; */
`;
